<template>
  <div class="channel">
    <nav-bar fixed :placeholder="true">
      <template #title>
        <van-tabs
          v-model:active="active"
          class="tab"
          color="#b57e48"
          @click-tab="onClickTopTab"
        >
          <van-tab name="a" title="我的结算" />
          <van-tab name="b" title="我的推广" />
          <van-tab name="c" title="优惠券" />
        </van-tabs>
      </template>
    </nav-bar>
    <div v-if="active == 'a'">
      <van-sticky :offset-top="46">
        <van-tabs
          v-model:active="orderType"
          color="#b57e48"
          @click-tab="onClickTab"
        >
          <van-tab
            :badge="getNum(badgeData.FollowingOrderTotal)"
            name="2"
            title="跟进中"
          />
          <van-tab
            :badge="getNum(badgeData.DealOrderTotal)"
            name="1"
            title="已成交"
          />
          <van-tab name="3" title="未成交" />
        </van-tabs>
      </van-sticky>
      <van-pull-refresh v-model="refreshing" class="" @refresh="onRefresh">
        <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="item in list"
            :key="item.UserId"
            class="list-item mt10 flex"
          >
            <div class="avatar">
              <van-image
                fit="cover"
                height="70"
                :src="api.FileHost + item.Avatar"
                width="70"
              />
            </div>
            <div class="info">
              <h2>{{ item.UserName }}</h2>
              <div class="">
                <p>提交时间：{{ item.SubmitTime }}</p>
                <p v-if="orderType == '1'">成交时间：{{ item.DealTime }}</p>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <van-tabbar safe-area-inset-bottom>
        <div class="fd flex">
          <div v-if="channel && !channel.Enable" class="disabled">
            <van-notice-bar mode="closeable" :scrollable="false">
              渠道未启用
            </van-notice-bar>
          </div>
          <div v-if="channel && getExpireDate" class="disabled">
            <van-notice-bar mode="closeable" :scrollable="false">
              {{ getExpireDate }}
            </van-notice-bar>
          </div>
          <div class="flex-1">
            <span>当月提成：</span>
            {{ bigNumberTransform(money(orderData.CurrentMonthSum)) || 0 }}元
          </div>
          <div class="flex-1">
            <span>累计提成：</span>
            {{ bigNumberTransform(money(orderData.TotalSum)) || 0 }}元
          </div>
        </div>
      </van-tabbar>
    </div>
    <div v-if="active == 'b'">
      <my-spread :channel="channel" :tab-active="active" />
    </div>
    <div v-if="active == 'c'">
      <CouponList :channel="channel" :tab-active="active" />
    </div>
  </div>
</template>
<script>
  import NavBar from '@/components/NavBar'
  import MySpread from './components/MySpread'
  import CouponList from './components/CouponList'
  import store from '@/store'
  import { bigNumberTransform, money, getExpire } from '@/utils'
  import { Toast, Dialog } from 'vant'
  import api from '@/api'
  export default {
    components: {
      NavBar,
      MySpread,
      CouponList,
    },
    data() {
      return {
        bigNumberTransform,
        money,
        api,
        active: 'a',
        orderType: '2',
        orderData: {},
        loading: false,
        finished: false,
        refreshing: false,
        badgeData: {},
        list: [],
        channel: null,
        page: {
          pageIndex: 1,
          pageSize: 8,
        },
      }
    },
    computed: {
      getExpireDate() {
        let res = ''
        if (this.channel) {
          res = getExpire(this.channel.ExpireDate)
        }
        return res
      },
    },
    // created() {
    //   this.init()
    // },
    activated() {
      this.init()
    },
    methods: {
      async init() {
        await this.getChannel()
        this.GetOrderStatistics()
        this.GetChannelOrderTotal()
      },
      getNum(item) {
        return item <= 0 ? '' : item
      },
      onClickTopTab() {
        // this.page.pageIndex = 1
        // this.list = []
      },
      onClickTab(item) {
        this.list = []
        this.finished = false
        this.page.pageIndex = 1
        this.orderType = item.name
        // 解决tab切换时 不onload问题
        setTimeout(() => {
          if (!this.list.length) this.onLoad()
        }, 500)
      },
      async getChannel() {
        const userInfo = store.getters['user/getUserInfo']
        const tenant = await store.getters['user/getTenant']
        return store
          .dispatch('user/GetChannel', {
            channelId: userInfo.UserId,
            tenantId: tenant.TenantId,
          })
          .then((data) => {
            this.channel = data.Data
            const { Data } = data
            if (!Data) {
              Dialog.alert({
                title: '温馨提示',
                confirmButtonText: '去申请渠道',
                message: '您还未申请渠道！',
              }).then(() => {
                this.$go('ChannelRegister', {}, 'replace')
              })
            }
          })
          .catch((e) => {
            console.log(e + '获取渠道信息失败')
          })
      },
      async GetOrderStatistics() {
        store
          .dispatch('user/GetOrderStatistics', {
            tenantId: (await store.getters['user/getTenant']).TenantId,
          })
          .then((data) => {
            const { Data } = data
            this.orderData = Data
          })
      },
      async GetChannelOrderTotal() {
        store
          .dispatch('user/GetChannelOrderTotal', {
            tenantId: (await store.getters['user/getTenant']).TenantId,
          })
          .then((data) => {
            this.badgeData = data.Data
          })
      },
      async onLoad() {
        const params = {
          pageIndex: this.page.pageIndex,
          pageSize: this.page.pageSize,
          channelOrderType: this.orderType,
          tenantId: (await store.getters['user/getTenant']).TenantId,
        }
        //return
        store
          .dispatch('user/OrderGetChannelOrder', params)
          .then((data) => {
            const { Data } = data

            Data.forEach((item) => {
              this.list.push(item)
            })
            setTimeout(() => {
              this.refreshing = false
              this.loading = false
            }, 500)
            this.page.pageIndex++
            if (this.page.pageSize > Data.length) {
              this.finished = true
            }
          })
          .catch((e) => {
            this.finished = true
            this.loading = false
          })
      },
      onRefresh() {
        // 清空列表数据
        this.list = []
        this.finished = false
        this.page.pageIndex = 1
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true
        this.onLoad()
        this.GetChannelOrderTotal()
        this.GetOrderStatistics()
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tab {
    ::v-deep .van-tab {
      padding: 0 16px;
      .van-tab__text {
        font-size: 16px;
      }
    }
  }
  .channel {
    .list-item {
      background: #fff;
      .avatar {
        padding: 16px;
        width: 70px;
        height: 70px;
        ::v-deep img {
          border-radius: 2px;
          overflow: hidden;
        }
      }
      .info {
        h2 {
          font-size: 16px;
          line-height: 16px;
          padding: 0;
          margin: 16px 0;
        }
        p {
          line-height: 1;
          color: #666;
          font-size: 14px;
          &:last-child {
            margin-top: 10px;
          }
        }
      }
    }
    .fd {
      // position: fixed;
      // left: 0;
      // right: 0;
      // bottom: 0;
      width: 100%;
      height: 56px;
      background: #fff;
      line-height: 55px;
      padding: 0 10px;
      .disabled {
        position: absolute;
        top: -40px;
        left: 0;
        right: 0;
      }
      span {
        font-size: 14px;
        color: #999;
      }
    }
  }
</style>
